export const domain = window.location.hostname;
// export const host = domain !== 'betareact.mhelli.com' ?  process.env.REACT_APP_DJANGO_API : 'https://betaapi.mhelli.com';
// export const host_nocdn = domain !== 'betareact.mhelli.com' ?  process.env.REACT_APP_NO_CDN_API : 'https://betanocdn.mhelli.com';
export const host = "https://tashrihiapi.mhelli.com";
export const host_nocdn = "https://tashrihiapi.mhelli.com";

export const host_v2 = process.env.REACT_APP_CSHARP_API;
export const imageLink = process.env.REACT_APP_IMAGE_Link;
// export const imageLink =  'http://192.168.38.128:8092';


// export const host = 'http://192.168.201.128:8092';
// export const host_nocdn = 'http://192.168.201.128:8092';

export const imageUrl = (uuid, options) => {
    options = options || {};
    let parameters = {
        uuid,
        width: Math.round(options.width) || '-',
        height: Math.round(options.height) || '-',
        type: options.type || 'cover',
    };
    // to run django locally : 
    if(domain === 'localhost'){
        return  imageLink + `/media/images/${parameters.uuid}/` 
    }
    if(options.type === 'orginal-img'){
        return imageLink + `/image/${parameters.uuid}`;  
    }
    else{
        return imageLink + `/image/${parameters.uuid}/${parameters.width}/` + 
        `${parameters.height}/${parameters.type}`;  
    }
};